import { AxiosRequestConfig } from 'axios';

/** 定义axios基础配置 */
export const axiosBaseOptions: AxiosRequestConfig = {
  baseURL: '',
  timeout: 80000,
};
